/**
 * We have a hard dependency on reflect-metadata package. Without it the
 * dependency lookup won't work, so we warn users when it's not loaded.
 */
if (!Reflect || !Reflect.getMetadata) {
    throw new Error('reflect-metadata should be installed otherwise please uninstall this package');
}
export { Injectable } from './di/injectable';
export { Inject } from './di/inject';
export { Container } from './di/container';
export { BrowserUtils } from './utils/browser';
export { Observer } from './utils/observer';
export { DOMUtils } from './utils/dom/index';
export { Api } from './utils/api';
export { Validator } from './utils/form/validator';
export { I18N } from './utils/i18n';
export { Component, ComponentSelector, ComponentSelectors, ComponentObject, ComponentElements, ComponentInjector, } from './utils/component';
export { Form, } from './utils/form/index';
export { ValidatorBuilder } from './utils/form/validator-builder';
export { Multi } from './multi-inherit';
//# sourceMappingURL=index.js.map